export const getNameInitials = (displayName: string | null): string => {
  if (!displayName) return '';

  const words = displayName
    .split(' ')
    .filter(Boolean)
    .map((word) => word[0]);
  const first = words[0] ?? '';
  const last = words.length > 1 ? words[words.length - 1] : '';

  return `${first}${last}`.toUpperCase();
};
